import { gql } from 'react-apollo';

export default gql`
  mutation realexOfferRequestInformation(
    $offerId: ID!
    $message: String
    $investorRealexId: ID
  ) {
    realexOfferRequestInformation(
      offerId: $offerId
      message: $message
      investorRealexId: $investorRealexId
    )
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/realexOfferRequestInformation.js